var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mode === 'edit')?_c('PageRequestCreate',_vm._g(_vm._b({attrs:{"resource":_vm.resource}},'PageRequestCreate',_vm.$attrs,false),_vm.$listeners)):(_vm.mode === 'view')?_c('PageRequestReview',_vm._g(_vm._b({attrs:{"resource":_vm.resource}},'PageRequestReview',_vm.$attrs,false),_vm.$listeners)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }